<template>
  <div class="live-component07 vod-form">
    <template v-if="!isLoading">
      <div class="filter-wrap live-filter" v-if="filter !== null">
        <FilterList :filter="filter" />
      </div>
      <div class="live-list-view-detail" :cell-type="thumbnailInfo.type">
        <template v-if="cellList.length > 0">
          <navigation-cell-wrapper
            v-for="(cell, index) in cellList"
            :key="'list_cell_' + index"
            :cell-info="cell"
          >
            <template #clickable-cell>
              <component
                :is="thumbnailInfo.componentName"
                :cell-info="cell"
                :cell-type="cellType"
                :thumbnail-info="thumbnailInfo"
              />
            </template>
          </navigation-cell-wrapper>
        </template>
        <template v-else>
          <div class="live-list-empty">
            <img src="../../assets/images/search/icon-error-74.png" alt="에러 아이콘"/>
            <p>추천 콘텐츠가 없어요</p>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import _ from 'lodash'
import fp from 'lodash/fp'
import LandscapeCell from '@/components/model/cell/LandscapeCell'
import LandscapePlayerCell from '@/components/model/cell/LandscapePlayerCell'
import FilterList from '@/pages/list/FilterList'
import { getLiveRecommendChannels } from '@/common/utils/request'
import { getThumbnailInfo } from '@/common/utils/common'
import navigationCellWrapper from '@/components/model/cellWrapper/NavigationCellWrapper'

const EVENT_RELOAD = 'reload'

export default {
  name: 'LiveAllList',
  components: {
    LandscapeCell,
    LandscapePlayerCell,
    FilterList,
    navigationCellWrapper
  },
  data () {
    return {
      isLoading: true,
      filter: null,
      cellType: '',
      cellList: [],
      thumbnailInfo: {},
      contentType: 'channel',
      query: null
    }
  },
  methods: {
    updateQuery (newQuery) {
      this.query = newQuery
    },
    setData () {
      this.isLoading = true
      const getData = response => response.data
      const setCellType = data => { this.cellType = _.get(data, 'cell_toplist.cell_type'); return data }
      const setThumbnailInfo = data => {
        fp.flow(
          fp.get(['cell_toplist', 'cell_type']),
          getThumbnailInfo,
          fp.thru(thumbnailInfo => { this.thumbnailInfo = thumbnailInfo }))(data)
        return data
      }
      const setList = data => { this.cellList = _.get(data, ['cell_toplist', 'celllist']); return data }
      const loadComplete = () => { this.isLoading = false }
      const setFilter = data => { this.filter = _.get(data, 'filter', null); return data }
      const defaultParameters = {
        isrecommend: 'n',
        contenttype: 'channel',
        WeekDay: 'all',
        uirank: '0',
        offset: 0,
        limit: 200,
        timeStamp: new Date().getTime()
      }
      getLiveRecommendChannels(_.assign(defaultParameters, _.set(this.query, 'genre', _.get(this.query, 'genre', 'all'))))
        .then(getData)
        .then(setThumbnailInfo)
        .then(setFilter)
        .then(setCellType)
        .then(setList)
        .then(loadComplete)
    },
    attachReloadEvent () {
      this.$events.$on(EVENT_RELOAD, () => {
        this.cellList = []
        this.setData()
      })
    },
    detachReloadEvent () {
      this.$events.$off(EVENT_RELOAD)
    }
  },
  created () {
    this.updateQuery(_.get(this.$route, 'query', {}))
    this.setData()
  },
  mounted () {
    this.attachReloadEvent()
  },
  beforeDestroy () {
    this.detachReloadEvent()
  },
  watch: {
    $route (newRoute) {
      const routeQuery = _.get(newRoute, 'query', {})
      this.updateQuery(routeQuery)
      this.setData()
    }
  }
}
</script>
<style scoped>
  .live-empty-cell-wrapper{
    display: inline-block;
    margin-right: 10px;
  }

  .live-empty-cell-wrapper:nth-child(5n){
    margin-right: 0;
  }

  .live-empty-cell-wrapper > .landscape{
    margin-right: 0
  }

  .live-list-empty{
    margin: 40px auto;
    padding: 54px 0;
  }

  .live-list-empty img,
  .live-list-empty p{
    display: block;
    margin: 0 auto;
    text-align: center;
  }

  .live-list-empty p{
    margin-top: 12px;
    font-size: 16px;
    line-height: 24px;
    color: #a5a5a5;
  }

  .live-list-view-detail{
    position: relative;
    overflow: hidden;
    margin: 0 auto;
    .landscape {
      margin-bottom: 40px;
      a {
        display: block;
      }
    }
    .portrait {
      margin: 0 10px 40px 0;
    }
    .thumb .thumb-image {
      border: 0;
    }
    .inner-box {
      float: left;
      margin: 0 10px 40px 0;
      .landscape,
      .portrait {
        margin: 0;
      }
    }
  }

  .live-list-view-detail .landscape.playnow .thumb-image::before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    background: transparent url(../../assets/images/common/element-icons-60-x-60-ic-now-play.svg) center
    no-repeat;
  }
</style>
